<template>
  <transition name="fade">
    <div v-if="show" class="modal">
      <div class="inner">
        <h4>{{ message }}</h4>
        <button type="button" name="button" class="btn btn-red btn-lg" @click="close()">Close</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      default: false,
      meta: { transitionName: 'slide' }
    },
    message: {
      default: '',
    },
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>
